module.exports = __webpack_public_path__ + "static/media/male-inactive.2c3e27f0.svg";